var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrafficSignAdditionalNightNar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "traffic_x5F_sign_x5F_additional_x5F_night_x5F_nar_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "traffic_x5F_sign_x5F_additional_x5F_night_x5F_nar"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.643,68C4.186,68,3,66.814,3,65.357V30.643C3,29.186,4.186,28,5.643,28h84.715C91.814,28,93,29.186,93,30.643v34.715 C93,66.814,91.814,68,90.357,68H5.643z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M90.357,29C91.263,29,92,29.737,92,30.643v34.714C92,66.263,91.263,67,90.357,67H5.643 C4.737,67,4,66.263,4,65.357V30.643C4,29.737,4.737,29,5.643,29H90.357 M90.357,27H5.643C3.631,27,2,28.631,2,30.643v34.714 C2,67.369,3.631,69,5.643,69h84.714C92.369,69,94,67.369,94,65.357V30.643C94,28.631,92.369,27,90.357,27L90.357,27z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.643,67C4.737,67,4,66.263,4,65.357V30.643C4,29.737,4.737,29,5.643,29h84.715C91.263,29,92,29.737,92,30.643v34.715 C92,66.263,91.263,67,90.357,67H5.643z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M21.68,41h2.42l5.74,9.68V41h2.36V55.24h-2.44l-5.74-9.681v9.681h-2.34V41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M35.04,41h2.46V55.24h-2.46V41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M45.5,47.5h5.36v2.3c0,0.987-0.094,1.837-0.279,2.55c-0.188,0.713-0.49,1.301-0.911,1.76 c-0.42,0.461-0.97,0.804-1.65,1.03c-0.68,0.227-1.52,0.341-2.52,0.341c-1.133,0-2.07-0.124-2.81-0.371 c-0.74-0.246-1.33-0.66-1.77-1.24S40.172,52.527,40,51.58c-0.173-0.947-0.26-2.12-0.26-3.521c0-1.413,0.093-2.59,0.28-3.53 c0.187-0.94,0.503-1.69,0.95-2.25s1.037-0.953,1.77-1.18c0.733-0.227,1.653-0.34,2.76-0.34c0.986,0,1.803,0.1,2.45,0.3 c0.647,0.2,1.167,0.497,1.56,0.89c0.393,0.394,0.68,0.887,0.86,1.48s0.297,1.277,0.35,2.05h-2.339c-0.04-0.48-0.124-0.88-0.25-1.2 c-0.127-0.32-0.303-0.573-0.53-0.76c-0.227-0.187-0.514-0.32-0.86-0.4S45.979,43,45.5,43c-0.667,0-1.207,0.063-1.62,0.19 c-0.414,0.126-0.737,0.373-0.97,0.74c-0.234,0.367-0.39,0.88-0.47,1.54s-0.12,1.517-0.12,2.57c0,1.187,0.04,2.137,0.12,2.85 c0.08,0.714,0.236,1.264,0.47,1.649c0.233,0.388,0.556,0.645,0.97,0.771c0.413,0.127,0.953,0.19,1.62,0.19 c0.56,0,1.03-0.053,1.41-0.16c0.38-0.106,0.683-0.29,0.91-0.551c0.227-0.26,0.39-0.612,0.49-1.059 c0.1-0.447,0.15-1.018,0.15-1.711v-0.44H45.5V47.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M53.039,41h2.46v6h5.58v-6h2.48V55.24h-2.48V49.1h-5.58v6.141h-2.46V41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M65.319,41H75.84v2.24h-4.021v12h-2.46v-12h-4.04V41z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrafficSignAdditionalNightNar);
export default __webpack_public_path__ + "static/media/icon-traffic_sign_additional_night_nar.a723245702b614d635f45e4dbbcf45d1.svg";
export { ForwardRef as ReactComponent };